<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="bannerType.id === null">{{ 'NEWBANNERTYPE' | translate }}</span>
            <span *ngIf="bannerType.id !== null">{{ 'EDITBANNERTYPE' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="bannerTypeForm" id="bannerTypeForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="bannerTypeForm" >
            <input type="hidden" name="id" id="bannerTypeId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-tag"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerTypeName" formControlName="name" type="text" pInputText [required]="true"> 
                      <label for="bannerTypeName" class="req">{{ 'NAME' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="bannerTypeForm.controls['name'].invalid && (bannerTypeForm.controls['name'].dirty || bannerTypeForm.controls['name'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerTypeForm.controls['name'].errors !== null">
                  <div *ngIf="bannerTypeForm.controls['name'].errors.required">
                   {{ 'NAMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-anchor"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerTypeSlug" formControlName="slug" type="text" pInputText [required]="true"> 
                      <label for="bannerTypeSlug" class="req">{{ 'SLUG' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="bannerTypeForm.controls['slug'].invalid && (bannerTypeForm.controls['slug'].dirty || bannerTypeForm.controls['slug'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerTypeForm.controls['slug'].errors !== null">
                  <div *ngIf="bannerTypeForm.controls['slug'].errors.required">
                   {{ 'SLUGREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerTypeExtensions" formControlName="extensions" type="text" pInputText [required]="true"> 
                      <label for="bannerTypeExtensions" class="req">{{ 'EXTENSIONS' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="bannerTypeForm.controls['extensions'].invalid && (bannerTypeForm.controls['extensions'].dirty || bannerTypeForm.controls['extensions'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerTypeForm.controls['extensions'].errors !== null">
                  <div *ngIf="bannerTypeForm.controls['extensions'].errors.required">
                   {{ 'EXTENSIONSREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-cog"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerTypeMimeTypes" formControlName="mimeTypes" type="text" pInputText [required]="true"> 
                      <label for="bannerTypeMimeTypes" class="req">{{ 'MIMETYPES' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="bannerTypeForm.controls['mimeTypes'].invalid && (bannerTypeForm.controls['mimeTypes'].dirty || bannerTypeForm.controls['mimeTypes'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerTypeForm.controls['mimeTypes'].errors !== null">
                  <div *ngIf="bannerTypeForm.controls['mimeTypes'].errors.required">
                   {{ 'MIMETYPESREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="bannerTypeIsPublished" formControlName="isPublished" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="bannerTypeIsPublished" class="p-d-inline-block p-ml-2 req">{{ 'ISPUBLISHED' | translate }}</label>
                </div>
                <div *ngIf="bannerTypeForm.controls['isPublished'].invalid && (bannerTypeForm.controls['isPublished'].dirty || bannerTypeForm.controls['isPublished'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerTypeForm.controls['isPublished'].errors !== null">
                  <div *ngIf="bannerTypeForm.controls['isPublished'].errors.required">
                   {{ 'ISPUBLISHEDREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKBANNERTYPES' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="bannerType.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!bannerTypeForm.valid || disableSubmit"> <!--  [disabled]="bannerTypeForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!bannerTypeForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

